import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import authContext from '../../context/authContext/authContext';
import { updateAchievementAction } from '../../redux/actions/achievementsAction';
import { getUsersAction } from '../../redux/actions/userAction';
import RenderError from '../../utils/RenderError';
import { achievementOptions, IMAGE_UPLOAD_ENDPOINT } from '../../utils/utils';
import { updateAdAction } from '../../redux/actions/adsAction';
import axios from 'axios';
import Loader from '../../utils/Loader';

const dataState = {
  image: '',
  url: '',
  title: '',
  loading: false,
  imageUrl: '',
  image: '',
  type: 'Announcement'
}

const errorState = {
  imageError: '',
  urlError: '',
  titleError: '',
  typeError: '',
  error: ''
}

const initialState = {
  ...dataState,
  ...errorState
};

const EditAd = ({ isOpen, toggle, ads, getAds, loading, adId }) => {
  const dispatch = useDispatch();
  const { getConfig } = useContext(authContext);
  const config = getConfig();

  const [state, setCompleteState] = useState(initialState);
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }));

  useEffect(() => {
    const ad = ads?.find((ad) => ad._id === adId);
    if (ad) {
      const { title, image, url, type } = ad;
      setState({ title, image, url, imageUrl: image, type, data: ad });
    }
  }, [adId])

  useEffect(() => {
    setState({ loading });
  }, [loading])

  const onHideModal = () => {
    setState({ ...initialState });
    toggle();
  }

  const validateUrl = () => {
    if (!state.url.trim()) {
      setState({ urlError: '*Please enter a valid URL' });
    }
  }

  const validateImage = () => {
    if (!state.image && !state.imageError) {
      setState({ imageError: '*Please choose valid Ad image' });
    }
  }

  const handleFileChange = (files) => {
    if (!(files || []).length) {
      setState({ imageError: "Upload an image" })
      return;
    }

    const file = files[0]
    const fileSize = file?.size * 0.000001

    const allowedTypes = ['image/jpeg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      setState({ imageError: 'Choose JPEG or PNG image' });
      return;
    }

    if (fileSize > 1) {
      setState({ imageError: "File size not higer than 1MB!" })
      toast.error("File size not higer than 1MB!");
      return;
    }

    const imageUrl = URL.createObjectURL(file);
    setState({ image: file, imageUrl });
  }


  const validateTitle = () => {
    if (!state.title?.trim()) {
      setState({ titleError: '*Please enter a valid title' });
    }
  };

  const validateType = () => {
    if (!state.type?.trim()) {
      setState({ typeError: '*Please enter a valid URL' });
    }
  }

  const editAd = async () => {
    if (state.loading) {
      return;
    }

    setState({ loading: true });
    const { title, url, image, imageUrl, type, data } = state;

    let fileUrl = state.imageUrl;
    if (image && typeof (image) !== "string" && imageUrl !== state.data.image) {
      const formData = new FormData();
      formData.append('file', image);
      formData.append('upload_preset', 'gleamdesk');
      formData.append('cloud_name', 'dnut9ipl0');
      try {
        const { data } = await axios.post(IMAGE_UPLOAD_ENDPOINT, formData);
        fileUrl = data?.url
      } catch (err) {
        toast.error(err?.response?.data?.error || err.message)
        return;
      }
    }

    const update = { ...data, image: fileUrl, url, title, type }
    dispatch(updateAdAction(update, config, getAds, onHideModal))
    setState({ loading: false });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const { image, url, title } = state;
    if (!image || !url || !title) {
      setState({ error: '*Please fill all the required fields' });
      return;
    }

    editAd();
  }

  const closeBtn = () => <button className='btn btn-close' onClick={onHideModal}>X</button>;

  return (
    <Modal isOpen={isOpen} toggle={onHideModal}>
      <ModalHeader toggle={onHideModal} close={closeBtn()}>
        <div className='d-flex align-items-center'>
          <div>Edit Ad</div>
          <div className='ml-3'>
            <Loader isLoading={state.loading} />
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <div class="form-group">
            <label>title</label>
            <input
              type="text"
              class="form-control"
              value={state?.title}
              onChange={(e) => setState({ title: e.target.value })}
              onFocus={() => setState({ titleError: '' })}
              onBlur={validateTitle}
              disabled={state.loading}
            />
            <RenderError error={state?.titleError} />
          </div>
          <div class="form-group">
            <label>Image</label>
            {state.imageUrl ? (
              <div className='d-flex align-items-center justify-content-between'>
                <div className='d-flex align-items-center justify-content-center mx-2'>
                  <img src={state.imageUrl} className='img-add-partner' alt="partner image" />
                </div>
                <div>
                  <input
                    type="file"
                    class="form-control"
                    onChange={(e) => handleFileChange(e.target.files)}
                    onBlur={validateImage}
                    onFocus={() => setState({ imageError: '', error: '' })}
                    disabled={state.loading}
                  />
                </div>
              </div>
            ) : (
              <>
                <input
                  type="file"
                  class="form-control"
                  onChange={(e) => handleFileChange(e.target.files)}
                  onBlur={validateImage}
                  onFocus={() => setState({ imageError: '', error: '' })}
                  disabled={state.loading}
                />
                <RenderError error={state?.imageError} />
              </>
            )}
          </div>

          <div class="form-group">
            <label>Redirect URL</label>
            <input
              type="url"
              class="form-control"
              value={state?.url}
              onChange={(e) => setState({ url: e.target.value })}
              onFocus={() => setState({ urlError: '', error: '' })}
              onBlur={validateUrl}
              disabled={state.loading}
            />
            <RenderError error={state?.urlError} />
          </div>

          <div class="form-group">
            <label>Ad Type</label>
            <input
              type="text"
              class="form-control"
              value={state?.type}
              onChange={(e) => setState({ type: e.target.value })}
              onFocus={() => setState({ typeError: '', error: '' })}
              onBlur={validateType}
              disabled={state.loading}
            />
            <RenderError error={state?.typeError} />
          </div>

          <RenderError error={state?.error} />
        </form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onHideModal} disabled={state.loading}>
          Cancel
        </Button>
        <Button type='submit' color="gleamdesk-blue gleamdesk-orange" onClick={handleSubmit} disabled={state.loading}>
          Update
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default EditAd;